import type {
  WrappedFieldArrayProps,
  WrappedFieldInputProps,
  WrappedFieldMetaProps,
} from "redux-form";
import { Field } from "redux-form";

import { Typography } from "@braintrust/braintrust-ui-components";
import { RichTextareaField } from "@js/forms/fields/rich-textarea";
import { required } from "@js/forms/validators";

import { FieldSectionPanelWithImportance } from "../fields/field-section-panel";

import style from "./style.module.scss";

export const NewApplicationAnswersField = ({
  fields,
}: WrappedFieldArrayProps) => {
  return fields.map((item, index) => {
    const question = fields.get(index).question;

    return (
      <Field
        id={index}
        key={item}
        name={`${item}.answer`}
        component={SingleQuestionField}
        question={question}
        validate={[required]}
      />
    );
  });
};

type SingleQuestionFieldProps = {
  input: WrappedFieldInputProps;
  meta: WrappedFieldMetaProps;
  question: string;
  id: number;
};

const SingleQuestionField = ({
  input,
  meta,
  question,
  id,
}: SingleQuestionFieldProps) => {
  const displayError = !!meta.error && (meta.submitFailed || meta.touched);

  return (
    <FieldSectionPanelWithImportance
      key={id}
      title="Please answer this question from the Client"
      fieldImportance="required"
      className={style.applicationAnswer}
      isError={displayError}
    >
      <Typography
        htmlFor={`${question}-${id}-id`}
        aria-labelledby={question}
        component="label"
        variant="paragraph"
        size="large"
        sx={{ mb: 2, display: "block" }}
      >
        {question}
      </Typography>
      {displayError && (
        <Typography component="p" variant="paragraph" error sx={{ mb: 2 }}>
          {meta.error}
        </Typography>
      )}
      <RichTextareaField
        id={`${question}-${id}-id`}
        input={input}
        meta={meta}
        placeholder="We want to hear from you. Please answer based on your own experience and communication style. Authentic answers help us better understand your background, thought process, and fit for the role."
        hideError
        required
        toolbar={[
          ["bold", "italic", "underline"],
          "format",
          ["align-left", "align-center", "align-right"],
          ["list", "indent"],
          ["emoji", "clear-formatting"],
          ["undo", "redo"],
        ]}
      />
    </FieldSectionPanelWithImportance>
  );
};
